export type ActionType = 'cancel' | 'close';

export type ContinueButtonCommand = 'continue' | 'cancel';

import { CallState, LoadingState } from "../../utilities/state.util";

export const cancelAndCloseDialogInitialState = {
  jobId: undefined as string | undefined,
  view: 'cancel' as ActionType,
  trigger: undefined as ActionType | undefined,
  eventsToCancel: {} as Record<string, boolean>,
  closedReason: undefined as string | undefined,
  cancelEventsCall: LoadingState.INIT as CallState,
  cancelAndCloseCall: LoadingState.INIT as CallState,
} as const;

export type CancelAndCloseDialogState = typeof cancelAndCloseDialogInitialState;
